import { Box, Typography } from '@mui/material';
import { useEffect, useState } from 'react';

import { currency } from '@shared/hooks/currencies';
import PaymentDetails from '@shared/components/PaymentDetails';
import InfoValueRow from '@shared/components/InfoValueRow';
import TaxesTooltip from '@FlightsComponents/TaxesTooltip';

const Price = ({
  infoFlightsSearch = {},
  cluster,
  isInUSD,
  cardData,
  isPayment,
}) => {
  const [adults, setAdults] = useState(0);
  const [childsBaby, setChildsBaby] = useState(0);
  const [childs, setChilds] = useState(0);

  useEffect(() => {
    const adultsQty = infoFlightsSearch?.adults_qty ?? 0;
    const childs = infoFlightsSearch?.childs ?? [];

    const counts = childs.reduce(
      (acc, child) => {
        if (child.age <= 1) acc.childsBaby += 1;
        else if (child.age >= 2 && child.age <= 11) acc.childs += 1;
        else if (child.age >= 12) acc.adults += 1;
        return acc;
      },
      { childsBaby: 0, childs: 0, adults: adultsQty }
    );

    setChildsBaby(counts.childsBaby);
    setChilds(counts.childs);
    setAdults(counts.adults);
  }, [infoFlightsSearch]);

  return (
    <Box id="FLIGHTSPRICE">
      {/* PRECIOS */}

      {isPayment && (
        <Typography
          sx={{
            width: '100%',
            color: '#000',
            fontWeight: 700,
            fontSize: { xs: '18px', md: '20px' },
            pb: 2,
            lineHeight: 1,
          }}
        >
          Detalle de tu pago
        </Typography>
      )}

      <Box
        sx={{
          textAlign: 'center',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        {/* Adultos, Menores, Infantes */}
        <Box sx={{ width: '100%' }}>
          <InfoValueRow
            label={`${adults} Adulto${adults > 1 ? 's' : ''}`}
            value={cluster?.composition_price.adt_price}
            isPrice
            isInUSD={isInUSD}
          />

          {childs > 0 && (
            <InfoValueRow
              label={`${childs} Menor${childs > 1 ? 'es' : ''}`}
              value={cluster?.composition_price.cnn_price}
              isPrice
              isInUSD={isInUSD}
            />
          )}

          {childsBaby > 0 && (
            <InfoValueRow
              label={`${childsBaby} Infante${childsBaby > 1 ? 's' : ''}`}
              value={cluster?.composition_price.inf_price}
              isPrice
              isInUSD={isInUSD}
            />
          )}
        </Box>

        {/* Impuestos y cargos */}
        <Box sx={{ width: '100%' }}>
          <TaxesTooltip
            tax_detail={cluster?.composition_price?.tax_detail}
            formatValue={value => currency(value, isInUSD)}
          >
            <InfoValueRow
              label="Impuestos:"
              value={cluster?.composition_price?.total_taxes}
              isPrice
              isInUSD={isInUSD}
            />
          </TaxesTooltip>

          {cluster?.composition_price?.country_tax > 0 && !isInUSD && (
            <InfoValueRow
              label="Impuesto PAIS"
              value={cluster?.composition_price?.country_tax}
              isPrice
            />
          )}

          {cluster?.composition_price?.taxQ1 > 0 && !isInUSD && (
            <InfoValueRow
              label={cluster?.composition_price?.taxQ1_name}
              value={cluster?.composition_price?.taxQ1}
              isPrice
            />
          )}

          {cluster?.composition_price?.total_charges > 0 && (
            <InfoValueRow
              label="Cargos:"
              value={cluster?.composition_price?.total_charges}
              isPrice
              isInUSD={isInUSD}
            />
          )}
        </Box>

        <PaymentDetails
          cardData={cardData}
          total={cluster?.composition_price?.total}
          isInUSD={isInUSD}
          productType="flight"
        />
      </Box>
    </Box>
  );
};

export default Price;
